export function getTransparentDataURL() {
  return "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAwAB/epARQABAAA//w6wAAAAAElFTkSuQmCC";
}
